import * as SearchActions from '../../state/search/search.action';

export class ESNController {
  constructor($state, $stateParams, $rootScope, EquipmentService, $ngRedux) {
    'ngInject';
    this.$state = $state;
    this.$rootScope = $rootScope;
    this.store = $ngRedux;
    this.EquipmentService = EquipmentService;
    this.loading = true;
    this.items = [];
    this.serialNumber = ($stateParams.serialNumber || '').trim();
  }

  $onInit() {
    if (this.serialNumber) {
      this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
      let query = {};
      // glc is Genie
      if (this.$rootScope.currentUser.claims['tenant:brand'] === 'glc')
        query['machine Serial Number'] = this.serialNumber;
      else query['onei3:serial'] = this.serialNumber;

      this.EquipmentService.getEquipmentSearch(null, null, null, null, null, null, query)
        .then(({ data }) => {
          if (data.hits.length === 1) {
            const asset = data.hits[0];
            this.$state.transitionTo('equipment.detail', {
              equipmentId: asset.id,
              title: asset.name,
            });
          } else {
            this.items = data.hits;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    } else this.$state.transitionTo('equipment.list');
  }

  $onDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  }

  mapStateToThis() {
    return {};
  }
  goToAsset(asset) {
    this.$state.transitionTo('equipment.detail', {
      equipmentId: asset.id,
      title: asset.name,
    });
  }
  goToAssets() {
    this.addQuery(this.serialNumber);
    this.$state.transitionTo('equipment.list');
  }
}
